import React from 'react';
import { Box } from '@mui/material';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';
import RolesHeader from './RolesHeader';

const InActiveRoles = ({ setValue }) => {
  const fetchInActiveRole = async () => {
    const res = await axios.get(API_URL + '/opportunities', {
      params: { status: 'Inactive', limit: 0 },
    });
    return res;
  };
  const { status, data } = useQuery(`fetchInActiveRole`, fetchInActiveRole);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <Box>
          <RolesHeader data={data.data.data} setValue={setValue} />
        </Box>
      )}
    </div>
  );
};

export default InActiveRoles;
